// ListDocument.js - Update the table headers and data rows
import useToastContext from "hooks/useToastContext";
import { AiFillEdit, AiFillEye, AiFillDelete } from "react-icons/ai";
import { apiPut } from "../../utils/apiFetch";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import apiPath from "../../utils/apiPath";
import { useContext } from "react";
import { isEmpty } from "lodash";
import helper from "../../utils/helpers";
import AuthContext from "context/AuthContext";
import { BsArrowUpShort } from "react-icons/bs";

const ListDocument = ({ 
  documentList, 
  page, 
  fetchDocuments, 
  handleEdit, 
  handleView, 
  deleteDocument,
  sort, 
  setSort, 
  manager 
}) => {
  const notification = useToastContext();
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);

  const handleStatusChange = async (item) => {
    try {
      const payload = {
        status: item?.status === "inactive" ? "active" : "inactive",
      };
      const path = `${apiPath.documentStatus}/${item?._id}`;
      const result = await apiPut(path, payload);
      if (result?.status === 200) {
        notification.success(result.data.message);
        fetchDocuments({ statusChange: true });
      }
    } catch (error) {
      console.log("error in status change:", error.message);
    }
  };

  const getYesNoLabel = (value) => {
    return value === 'yes' ? t('YES') : t('NO');
  };

  return (
    <div>
      <div className="p-3">
        <div className="overflow-x-auto rounded-lg border relative">
          <table className="text-[#6c6c6c] w-full text-xs text-left dark:text-gray-400">
            <thead className="border border-[#E1E6EE] bg-[#E1E6EE] text-xs text-gray-900 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th className="py-3 px-6" scope="col">
                  Sr no.
                </th>
                <th scope="col" className="px-6 py-3">
                  {t("DOCUMENT_NAME")}
                </th>
                <th scope="col" className="px-6 py-3">
                  {t("DOCUMENT_CATEGORY")}
                </th>
                {/* <th scope="col" className="px-6 py-3">
                  {t("DESCRIPTION")}
                </th> */}
                <th
                  scope="col"
                  className="px-6 cursor-pointer py-3"
                  onClick={() => {
                    if (sort.sortType === "asc" && sort.sortBy === "createdAt") {
                      setSort({
                        sortBy: "createdAt",
                        sortType: "desc",
                      });
                    } else {
                      setSort({
                        sortBy: "createdAt",
                        sortType: "asc",
                      });
                    }
                  }}
                >
                  <div className="flex justify-start">
                    <span>{t("CREATED_DATE")}</span>
                    <span>
                      {sort.sortBy === "createdAt" && sort.sortType === "asc" && <BsArrowUpShort className="w-4 h-4" />}
                      {sort.sortBy === "createdAt" && sort.sortType === "desc" && <BsArrowUpShort className="h-4 rotate-180 w-4" />}
                    </span>
                  </div>
                </th>
                <th scope="col" className="px-6 py-3 text-center">
                  {t("O_STATUS")}
                </th>
                <th scope="col" className="text-center py-3 px-6">
                  {t("O_ACTION")}
                </th>
              </tr>
            </thead>
            <tbody>
              {documentList && documentList.map((item, i) => {
                return (
                  <tr key={i} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50">
                    <th scope="row" className="py-4 px-6 border-r font-medium text-gray-900 dark:text-white">
                      {i + 1 + 10 * (page - 1)}
                    </th>
                    <td className="py-4 px-6 border-r text-gray-900">
                      <div className="font-medium">{item?.name}</div>
                    </td>
                    <td className="py-4 px-6 border-r text-gray-900">
                      <div className="font-medium">
                        {item?.category?.name || item?.category || '-'}
                      </div>
                    </td>
                    {/* <td className="py-4 px-6 border-r text-gray-900">
                      <div className="max-w-xs truncate" title={item?.description}>
                        {item?.description || '-'}
                      </div>
                    </td> */}
                    <td className="py-4 px-6 border-r text-left text-gray-900">
                      {dayjs(item?.createdAt).format("MM-DD-YYYY h:mm A")}
                    </td>
                    <td className="py-4 px-6 border-r text-gray-900 text-center">
                      <label className="inline-flex items-center cursor-pointer relative" title={`${item?.status === "active" ? "Active" : "Inactive"}`}>
                        <input
                          checked={item?.status === "active"}
                          type="checkbox"
                          className="sr-only peer"
                          onChange={(e) => 
                            helper.alertFunction(
                              `Are you sure you want to ${e.target.checked ? "active" : "inactive"} '${item.name}'?`, 
                              item, 
                              handleStatusChange
                            )
                          }
                        />
                        <div className="w-10 h-5 bg-gray-200 rounded-full peer-focus:ring-blue-300 peer peer-focus:ring-0 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-LightBlue" />
                      </label>
                    </td>
                    <td className="py-4 px-6 text-gray-900">
                      <div className="flex justify-center space-x-2">
                        {/* <button
                          onClick={() => handleView(item)}
                          className="hover:text-blue-600 transition duration-150 ease-in-out p-1"
                          title={t('VIEW_DOCUMENT')}
                        >
                          <AiFillEye className="w-5 h-5 text-gray-600 hover:text-blue-600" />
                        </button> */}
                        <button
                          onClick={() => handleEdit(item)}
                          className="hover:text-green-600 transition duration-150 ease-in-out p-1"
                          title={t('EDIT_DOCUMENT')}
                        >
                          <AiFillEdit className="w-5 h-5 text-gray-600 hover:text-green-600" />
                        </button>
                        <button
                          onClick={() => deleteDocument(item._id)}
                          className="hover:text-red-600 transition duration-150 ease-in-out p-1"
                          title={t('DELETE_DOCUMENT')}
                        >
                          <AiFillDelete className="w-5 h-5 text-gray-600 hover:text-red-600" />
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
              {isEmpty(documentList) ? (
                <tr className="dark:bg-gray-800 bg-white border-b text-center dark:border-gray-700">
                  <td className="py-8 px-6" colSpan={9}>
                    {t("O_NO_RECORD_FOUND")}
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ListDocument;